import gsap from 'gsap';
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-best-selling-products-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            const target = slider.querySelector('[data-best-selling-products-slider-target]');
            new Swiper(target, {
                modules: [Navigation],
                slidesPerView: 3.1,
                spaceBetween: 12,
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                    1024: {
                        slidesPerView: 6,
                        spaceBetween: 30
                    }
                },
                navigation: {
                    nextEl: slider.querySelector('[data-best-selling-products-slider-next]'),
                    prevEl: slider.querySelector('[data-best-selling-products-slider-prev]'),
                }
            });
        });
    }

}